/** @format */

import { NgModule } from '@angular/core';
import { Chain, Environment } from '@shared/data-access/interfaces';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { chain } from '@core/chain';
import { WINDOW_PROVIDERS } from '@shared/data-access/services';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { environment } from '../environments';

@NgModule({
  declarations: [AppComponent],
  imports: [AppRoutingModule, BrowserAnimationsModule],
  providers: [
    { provide: Chain, useValue: chain || {} },
    { provide: Environment, useValue: environment || {} },
    WINDOW_PROVIDERS,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
